<template>
    <div>
         <!-- main-area -->
         <main class="fix">
                <!-- breadcrumb-area -->
                <section class="breadcrumb__area breadcrumb__bg">
                    <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100 kantor-bg"></div>
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="breadcrumb__content">
                                    <h2 class="title">Foto Kegiatan</h2>
                                    <nav aria-label="breadcrumb">
                                        <ol class="breadcrumb">
                                            <li class="breadcrumb-item"><a href="javascript:void(0);">Galeri</a></li>
                                            <li class="breadcrumb-item active" aria-current="page">Foto Kegiatan</li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="breadcrumb__shape">
                        <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
                    </div>
                </section>

                <section class="about__area-five about__area-seven">
                <div class="container">
                    
                    <div class="row gutter-24">


                        <div class="col-lg-3 col-md-6" v-for="data in list_data" :key="data.id">
                            <div class="project__item-two">
                                <div class="project__thumb-two">
                                    <img :src="file_path+data.file" alt="FOTO" />
                                </div>
                                <div class="project__content-two">
                                    <h2 class="title"><a @click.prevent="showModal(data)">{{data.judul}}</a></h2>
                                    <!-- <span>{{data.judul}}</span> -->
                                    <span>{{convert_tgl(data.createAt)}}</span>
                                    <div class="link-arrow link-arrow-two">
                                        <a @click.prevent="showModal(data)">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 15" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6293 3.27956C17.7117 2.80339 17.4427 2.34761 17.0096 2.17811C16.9477 2.15384 16.8824 2.13551 16.8144 2.12375L6.96087 0.419136C6.4166 0.325033 5.89918 0.689841 5.80497 1.23409C5.71085 1.77828 6.0757 2.29576 6.61988 2.38991L14.0947 3.68293L1.3658 12.6573C0.914426 12.9756 0.806485 13.5994 1.12473 14.0508C1.44298 14.5022 2.06688 14.6101 2.51825 14.2919L15.2471 5.31752L13.954 12.7923C13.8599 13.3365 14.2248 13.854 14.7689 13.9481C15.3132 14.0422 15.8306 13.6774 15.9248 13.1332L17.6293 3.27956Z" fill="currentcolor" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6293 3.27956C17.7117 2.80339 17.4427 2.34761 17.0096 2.17811C16.9477 2.15384 16.8824 2.13551 16.8144 2.12375L6.96087 0.419136C6.4166 0.325033 5.89918 0.689841 5.80497 1.23409C5.71085 1.77828 6.0757 2.29576 6.61988 2.38991L14.0947 3.68293L1.3658 12.6573C0.914426 12.9756 0.806485 13.5994 1.12473 14.0508C1.44298 14.5022 2.06688 14.6101 2.51825 14.2919L15.2471 5.31752L13.954 12.7923C13.8599 13.3365 14.2248 13.854 14.7689 13.9481C15.3132 14.0422 15.8306 13.6774 15.9248 13.1332L17.6293 3.27956Z" fill="currentcolor" />
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>


                





                    </div>

                                    <div class="pagination-wrap mt-40">
                                        <nav aria-label="Page navigation example">
                                            <ul class="pagination list-wrap">
                                                <li class="page-item"><a @click="btn_prev" class="page-link" href="javascript:void(0);"><i class="fas fa-angle-double-left"></i></a></li>
                                                <li class="page-item active" ><a class="page-link" href="#" style="font-size: 12px !important;">{{page_first}} - {{page_last}}</a></li>
                                                <li class="page-item next-page"><a class="page-link" @click="btn_next" href="javascript:void(0);"><i class="fas fa-angle-double-right"></i></a>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>

                    <!-- <div class="pagination-wrap mt-40">
                        <nav aria-label="Page navigation example">
                            <ul class="pagination list-wrap">
                            <li class="page-item" :class="{ disabled: page_first === 1 }">
                                <a class="page-link" href="#" @click.prevent="btn_prev"><i class="fas fa-angle-double-left"></i></a>
                            </li>
                            <li
                                class="page-item"
                                v-for="page in page_last"
                                :key="page"
                                :class="{ active: page === page_first }"
                            >
                                <a class="page-link" href="#" @click.prevent="go_to_page(page)">{{ page }}</a>
                            </li>
                            <li class="page-item" :class="{ disabled: page_first === page_last }">
                                <a class="page-link" href="#" @click.prevent="btn_next"><i class="fas fa-angle-double-right"></i></a>
                            </li>
                            </ul>
                        </nav>
                    </div> -->

                </div>
                <div class="about__shape-wrap-four">
                    <img src="assets/img/images/h4_about_shape01.png" alt="">
                    <img src="assets/img/images/h4_about_shape02.png" alt="" data-parallax='{"x" : -80 , "y" : -80 }'>
                </div>




            </section>
                    <!-- about-area-end -->
                <!-- breadcrumb-area-end -->
               
                
            </main>
            <!-- main-area-end -->
    
    
    </div>

    <div class="modal fade" id="fotoModal" tabindex="-1" aria-labelledby="fotoModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="fotoModalLabel">{{form.judul }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Tutup"></button>
                </div>
                <div class="modal-body text-center">
                    <img :src="file_path + form.file" alt="Foto Detail" class="img-fluid mb-3" />
                    <p>{{ form.deskripsi }}</p>
                </div>
                </div>
            </div>
        </div>
    </template>

    <script>

        export default {

            data() {
                return {
                    file_path: this.$store.state.URL_APP + "uploads/",
                    list_data: [],
                    page_first: 1,
                    page_last: 0,
                    cari_value: "",
                    uraian: "",
                    form : {
                        id : '',
                        judul : '',
                        deskripsi : '',
                        file : '',
                        unit_kerja : '',
                        status : '',
                        createBy : '',
                        createAt : '',
                    },
                }
            },
            methods: {

                showModal(data) {
                this.form = data;

                // trigger Bootstrap Modal (v5)
                // eslint-disable-next-line no-undef
                const modal = new bootstrap.Modal(document.getElementById('fotoModal'));
                modal.show();
            },
                getView: function() {
                    this.cek_load_data = true;
                    fetch(this.$store.state.ADD_FOTO + "view", {
                        method: "POST",
                        headers: {
                        "content-type": "application/json",
                        },
                        body: JSON.stringify({
                        data_ke: this.page_first,
                        cari_value: this.cari_value,
                        kategori: this.kategori,
                        })
                    })
                    .then(res => res.json())
                    .then(res_data => {
                        console.log(res_data);
                        // console.log('aaaaaaaaaaaaaa')
                        this.list_data = res_data.data;
                        this.page_last = res_data.jml_data;
                        this.cek_load_data = false;
                    });
                },
                    

            // ================== PAGINASI ====================
            alertku: function(type, title) {
            this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
            });
            },

            btn_prev() {
                if (this.page_first > 1) {
                    this.page_first--;
                    this.getView();
                }
                },
                btn_next() {
                if (this.page_first < this.page_last) {
                    this.page_first++;
                    this.getView();
                }
                },

                go_to_page(page) {
                    this.page_first = page;
                    this.getView(); // atau nama method Anda untuk fetch data
                },

            cari_data : function(){

                this.page_first = 1;
                this.getView();
            },
            onFileSelected: function(event) {
            this.form.file = event.target.files[0];
            },
            convert_tgl: function(dateString) {
            var date = new Date(dateString);
            return date.getDate() + "/" + date.getMonth() + "/" + date.getFullYear();
            }
            // ================== PAGINASI ====================
            },
            // =============================================================== METHODS =========================================================================


            convert_tgl : function(dateString){
                  var date = new Date(dateString);
                  var getBulan = date.getMonth() + 1; var bulan = '';
                  if (getBulan == '1') {bulan = 'Jan'} 
                  else if(getBulan == '2') {bulan = 'Feb'}
                  else if(getBulan == '3') {bulan = 'Mar'}
                  else if(getBulan == '4') {bulan = 'Apr'}
                  else if(getBulan == '5') {bulan = 'Mei'}
                  else if(getBulan == '6') {bulan = 'Jun'}
                  else if(getBulan == '7') {bulan = 'Jul'}
                  else if(getBulan == '8') {bulan = 'Agt'}
                  else if(getBulan == '9') {bulan = 'Sep'}
                  else if(getBulan == '10') {bulan = 'Okt'}
                  else if(getBulan == '11') {bulan = 'Nov'}
                  else if(getBulan == '12') {bulan = 'Des'}



                  return date.getDate() + " " + bulan + " " + date.getFullYear();
              },



            mounted() {

            this.getView();


                
            }
            };



    </script>



